module.exports = __webpack_public_path__ + "static/img/3.0e81f7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/notice/3.png
// module id = m5XX
// module chunks = 1